 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-0d98aaf8":"b6be7559","chunk-114363d4":"9e3f31cd","chunk-19080138":"9bb89bd9","chunk-1c499797":"cbf77366","chunk-1f1a5972":"2ea97ce8","chunk-2b3cf397":"0e14165f","chunk-26738b55":"43473aa4","chunk-33116f9a":"787fb0b1","chunk-599007dc":"56ac3edc","chunk-401a708f":"13924914","chunk-350ba5da":"7f675a0d","chunk-464bc420":"1163dbd8","chunk-473cc469":"3d2e3f52","chunk-5c92d6c0":"1f5fff3f","chunk-0b6c76cb":"42cb2553","chunk-64f66157":"768f5cb0","chunk-769ecb47":"c8daff13","chunk-a2af22ca":"8fec686d","chunk-e077ba0c":"944b44c9","chunk-2070a28e":"2c1afc91","chunk-2d0a43c3":"6ae9a1e7","chunk-2d0a4885":"bf75f14a","chunk-2d0ac931":"cc71baa3","chunk-2d0b93c5":"ed3beb42","chunk-2d0c211b":"56bba833","chunk-2d0cf315":"c8f5219d","chunk-2d0e2170":"5cf09853","chunk-2d0f0050":"43ca0cc8","chunk-2d208e4e":"b047ec48","chunk-2d208fba":"7cafd614","chunk-2d212be3":"a44d5113","chunk-2d216b27":"9c0ea3b3","chunk-2d217def":"9b86ebe8","chunk-2d21a9aa":"bdd6764c","chunk-2d222cca":"4226e9f6","chunk-2d22895d":"4ebcf334","chunk-2d23721e":"7970ea5d","chunk-31702efe":"a1719356","chunk-2ae21eb2":"305df5b3","chunk-6c7157f6":"1b3c2f15","chunk-da1e78f0":"9ccddea6","chunk-38e2a829":"cb3bb23c","chunk-390384eb":"63616a50","chunk-43fdf3cf":"225afc72","chunk-31249121":"747f417d","chunk-75a9d1d4":"585683f7","chunk-4cd0798d":"e430c4c4","chunk-565dcac2":"08f932b4","chunk-5876d358":"a00fd950","chunk-663d91fc":"16c72dc8","chunk-7a780398":"adc2b3e3","chunk-7b5413de":"d2066cc5","chunk-bdac1d78":"a7759ec6","stencil-polyfills-css-shim":"b85f8bdc","stencil-polyfills-dom":"6e9caa76","chunk-4467708a":"fadff9b0","chunk-4c5627b4":"15cd2ec5","chunk-74924d81":"44e3d7d6","chunk-1720e301":"41ce0acc","chunk-65d00c3e":"d982e876","chunk-58453dd6":"0c72aa66","chunk-d26de402":"3434f00c","chunk-00e33c79":"746917a2","chunk-2d0c7af3":"8549e2b5","chunk-2d0c8407":"d4c26803","chunk-3c4483fb":"af790f6b","chunk-6d48844a":"8ea08b27","chunk-9891076e":"d941463b","chunk-ac1b6934":"0c4f7edd","chunk-1901a988":"dde682ee","chunk-b0549c54":"0b9e0fba","chunk-5c984714":"f01a0a21","chunk-2d238653":"5f6cf065","chunk-929cdb34":"ada5eb82","chunk-5fc5ab98":"3b32f75a","chunk-16d7f943":"bffc9b7d","chunk-1dc74f47":"8aaa97f4","chunk-20c937ff":"2327c113","chunk-cb5cd53e":"0832f079","chunk-0cf343f2":"befa5ceb","chunk-d4ee8960":"7ca475c0","chunk-ef4328e0":"a138933b","chunk-a09c1f8a":"f2b8163c","chunk-2d0cc074":"506137fb","chunk-462e102d":"d9177285","chunk-2d216280":"df09f0ca","chunk-4fd8799c":"935578cb","chunk-52855584":"468d4f08","chunk-6dbd82ca":"2003e49b","chunk-e2bf65e0":"3815cc24","chunk-2d0c1d9a":"4a43e084","chunk-2d20f3b3":"eb779a16","chunk-3bafb15e":"2c620f7e","chunk-4cdd3fc1":"c7871354","chunk-c68f878a":"480e2c62","chunk-5af9bc0e":"c5192b59","chunk-779a4182":"f7b7d336","chunk-39266be4":"cbfd8063","chunk-0743417f":"8512eef4","chunk-20e32000":"41f5b710","chunk-64a76e53":"4c7ced1d","chunk-32702eb6":"21a74827","chunk-0ffc7de6":"908cc5c5","chunk-0cc1ee88":"621b5764","chunk-2d0ea110":"7e527830","chunk-2d2214f1":"47419d09","chunk-2d0a4f60":"bb66f22a","chunk-2d0ab819":"0fe61375","chunk-2d0b21f3":"cdb82490","chunk-2d0cc9d8":"a1760061","chunk-2d0d70b7":"61a76069","chunk-2d2093c1":"bc097750","chunk-2d2100cb":"6ecd3f3d","chunk-2d2169b9":"03f81f5c","chunk-2d216d7a":"b3ce7302","chunk-2d216f1a":"fdeab877","chunk-2d2214fd":"c24fb1ae","chunk-2d22493e":"3bb383cb","chunk-2d229999":"b1e876f0","chunk-7736c7e4":"3678aa22"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0d98aaf8":1,"chunk-114363d4":1,"chunk-19080138":1,"chunk-1c499797":1,"chunk-1f1a5972":1,"chunk-2b3cf397":1,"chunk-26738b55":1,"chunk-33116f9a":1,"chunk-599007dc":1,"chunk-401a708f":1,"chunk-350ba5da":1,"chunk-473cc469":1,"chunk-5c92d6c0":1,"chunk-0b6c76cb":1,"chunk-64f66157":1,"chunk-769ecb47":1,"chunk-a2af22ca":1,"chunk-e077ba0c":1,"chunk-2070a28e":1,"chunk-2ae21eb2":1,"chunk-6c7157f6":1,"chunk-da1e78f0":1,"chunk-38e2a829":1,"chunk-390384eb":1,"chunk-43fdf3cf":1,"chunk-31249121":1,"chunk-75a9d1d4":1,"chunk-4cd0798d":1,"chunk-565dcac2":1,"chunk-5876d358":1,"chunk-663d91fc":1,"chunk-7a780398":1,"chunk-7b5413de":1,"chunk-bdac1d78":1,"chunk-4467708a":1,"chunk-4c5627b4":1,"chunk-74924d81":1,"chunk-1720e301":1,"chunk-58453dd6":1,"chunk-d26de402":1,"chunk-00e33c79":1,"chunk-3c4483fb":1,"chunk-6d48844a":1,"chunk-9891076e":1,"chunk-ac1b6934":1,"chunk-1901a988":1,"chunk-b0549c54":1,"chunk-929cdb34":1,"chunk-5fc5ab98":1,"chunk-16d7f943":1,"chunk-1dc74f47":1,"chunk-20c937ff":1,"chunk-cb5cd53e":1,"chunk-0cf343f2":1,"chunk-d4ee8960":1,"chunk-ef4328e0":1,"chunk-a09c1f8a":1,"chunk-462e102d":1,"chunk-4fd8799c":1,"chunk-52855584":1,"chunk-6dbd82ca":1,"chunk-e2bf65e0":1,"chunk-3bafb15e":1,"chunk-4cdd3fc1":1,"chunk-c68f878a":1,"chunk-5af9bc0e":1,"chunk-779a4182":1,"chunk-39266be4":1,"chunk-0743417f":1,"chunk-20e32000":1,"chunk-64a76e53":1,"chunk-32702eb6":1,"chunk-0ffc7de6":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-0d98aaf8":"c1668527","chunk-114363d4":"1d191148","chunk-19080138":"4d3894b2","chunk-1c499797":"9957f1e2","chunk-1f1a5972":"04adf890","chunk-2b3cf397":"9790f5e2","chunk-26738b55":"341611cb","chunk-33116f9a":"0a6c3744","chunk-599007dc":"2ad1bb6b","chunk-401a708f":"fb7ff769","chunk-350ba5da":"24e45155","chunk-464bc420":"31d6cfe0","chunk-473cc469":"854a4d6a","chunk-5c92d6c0":"c1da0eb2","chunk-0b6c76cb":"2d89e3dc","chunk-64f66157":"f205a3e7","chunk-769ecb47":"e25fe3c9","chunk-a2af22ca":"341611cb","chunk-e077ba0c":"3b156ef3","chunk-2070a28e":"218fa183","chunk-2d0a43c3":"31d6cfe0","chunk-2d0a4885":"31d6cfe0","chunk-2d0ac931":"31d6cfe0","chunk-2d0b93c5":"31d6cfe0","chunk-2d0c211b":"31d6cfe0","chunk-2d0cf315":"31d6cfe0","chunk-2d0e2170":"31d6cfe0","chunk-2d0f0050":"31d6cfe0","chunk-2d208e4e":"31d6cfe0","chunk-2d208fba":"31d6cfe0","chunk-2d212be3":"31d6cfe0","chunk-2d216b27":"31d6cfe0","chunk-2d217def":"31d6cfe0","chunk-2d21a9aa":"31d6cfe0","chunk-2d222cca":"31d6cfe0","chunk-2d22895d":"31d6cfe0","chunk-2d23721e":"31d6cfe0","chunk-31702efe":"31d6cfe0","chunk-2ae21eb2":"68b79826","chunk-6c7157f6":"626caa8d","chunk-da1e78f0":"4fb5dd30","chunk-38e2a829":"07e99984","chunk-390384eb":"517de8f4","chunk-43fdf3cf":"d1d7c646","chunk-31249121":"4878eeba","chunk-75a9d1d4":"a722de9a","chunk-4cd0798d":"ed741d80","chunk-565dcac2":"07e99984","chunk-5876d358":"3cc15b66","chunk-663d91fc":"12058e1a","chunk-7a780398":"f6dc57e2","chunk-7b5413de":"fe39eb1e","chunk-bdac1d78":"491bf599","stencil-polyfills-css-shim":"31d6cfe0","stencil-polyfills-dom":"31d6cfe0","chunk-4467708a":"963ddf7d","chunk-4c5627b4":"77b82084","chunk-74924d81":"1a9f1040","chunk-1720e301":"9c8bd291","chunk-65d00c3e":"31d6cfe0","chunk-58453dd6":"3ffa6408","chunk-d26de402":"9d3a0b58","chunk-00e33c79":"3da28bf5","chunk-2d0c7af3":"31d6cfe0","chunk-2d0c8407":"31d6cfe0","chunk-3c4483fb":"626caa8d","chunk-6d48844a":"bf145334","chunk-9891076e":"ad2a3271","chunk-ac1b6934":"a22277ac","chunk-1901a988":"3286522e","chunk-b0549c54":"91bf4ad8","chunk-5c984714":"31d6cfe0","chunk-2d238653":"31d6cfe0","chunk-929cdb34":"c91fe02c","chunk-5fc5ab98":"33d6148b","chunk-16d7f943":"4e19a397","chunk-1dc74f47":"223f9ded","chunk-20c937ff":"517de8f4","chunk-cb5cd53e":"c884785b","chunk-0cf343f2":"68b79826","chunk-d4ee8960":"4d3894b2","chunk-ef4328e0":"626caa8d","chunk-a09c1f8a":"f4f2c1ce","chunk-2d0cc074":"31d6cfe0","chunk-462e102d":"51414f62","chunk-2d216280":"31d6cfe0","chunk-4fd8799c":"80b8dbff","chunk-52855584":"e3a72982","chunk-6dbd82ca":"dc88a913","chunk-e2bf65e0":"dc88a913","chunk-2d0c1d9a":"31d6cfe0","chunk-2d20f3b3":"31d6cfe0","chunk-3bafb15e":"95dcbb53","chunk-4cdd3fc1":"193b24e7","chunk-c68f878a":"c884785b","chunk-5af9bc0e":"218fa183","chunk-779a4182":"f9de39f8","chunk-39266be4":"491bf599","chunk-0743417f":"2946e1a0","chunk-20e32000":"f4f2c1ce","chunk-64a76e53":"413270a8","chunk-32702eb6":"654a548c","chunk-0ffc7de6":"a0d677cc","chunk-0cc1ee88":"31d6cfe0","chunk-2d0ea110":"31d6cfe0","chunk-2d2214f1":"31d6cfe0","chunk-2d0a4f60":"31d6cfe0","chunk-2d0ab819":"31d6cfe0","chunk-2d0b21f3":"31d6cfe0","chunk-2d0cc9d8":"31d6cfe0","chunk-2d0d70b7":"31d6cfe0","chunk-2d2093c1":"31d6cfe0","chunk-2d2100cb":"31d6cfe0","chunk-2d2169b9":"31d6cfe0","chunk-2d216d7a":"31d6cfe0","chunk-2d216f1a":"31d6cfe0","chunk-2d2214fd":"31d6cfe0","chunk-2d22493e":"31d6cfe0","chunk-2d229999":"31d6cfe0","chunk-7736c7e4":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
